<template>
  <v-container fluid>	    			
    <v-row>
      <v-col>
        <v-data-table
          class="baseInlineEditingDataTable"
          :headers="headers"
          :items="listItems"
          :no-data-text="noDataText"
          :loading="isLoading"
          :loading-text="loadingText"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
        >
          <template v-slot:top>
            <slot name="topSlot"></slot>              
          </template>          

          <!-- Inline Editing -->
          <template v-slot:body="{items}" v-if="true">            
            <slot
              v-if="items.length !== 0"
              name="editRow" 
              :items="items"
            ></slot>
            <tbody v-else>
              <tr class="v-data-table__empty-wrapper">                
                  <td :colspan="headers.length">
                    <div :alvqa="alvqa + '-list-no-data-text'">{{ noDataText }}</div>
                  </td>
              </tr>        
            </tbody>           
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="pages() > 1" 
        align="center"
        align-content="center"
      >
      <v-pagination
        total-visible="7"
        v-model="page"
        :length="pages()"
      >
      </v-pagination>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BaseInlineEditingDataTable",
  props: {
    headers: {
      required: true,
      type: Array,
      default: []
    },
    context: {
      // used to get and set all page specific data.
      required: true,
      type: String,
      default: ""
    },
    itemKey: {
      // unique "value" of header/column to identify the selected item(s). See e.g. "Works.vue": computed "headers".
      type: String //  vuetify default: 'id'
    },
    alvqa: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      page: 1,
    }
  },
  computed: {
    listItems() {
      return this.$store.getters["get" + this.context];
    },
    itemsPerPage() { 
      return this.$store.getters.getItemsPerPage 
    },
    loadingText() {
      return this.$t("lang_GENERAL_LOADING_DATATABLE");
    },
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
    noDataText() {
      return this.$t(this.$store.getters.getNoDataText);
    }
  },
   methods: {
		// Calculates how many pages are available.
		pages() {
			if (this.itemsPerPage == null || this.listItems.length == null) return 0 
        return Math.ceil(this.listItems.length / this.itemsPerPage)
    },
    addNewRow(){
        this.$store.dispatch('addNewRow'+this.context)
    }   
   },
   created(){
     if(this.context === "Credentials") {
        this.$store.commit('setIsLoading', true)
        this.$store.dispatch('fetch'+this.context)
     }
   }
};
</script>

<style>
  .baseInlineEditingDataTable table {
    table-layout: fixed;
  }
  .baseInlineEditingDataTable table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  alvcell{
    height: 18px
  }
</style>